/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Enum for feedback styles
 */
export type TaskFeedbackStyleEnum = (typeof TaskFeedbackStyleEnum)[keyof typeof TaskFeedbackStyleEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskFeedbackStyleEnum = {
  'autograder-student-feedback': 'autograder-student-feedback',
  'plt-student-comment': 'plt-student-comment',
  'plt-business-student-comment': 'plt-business-student-comment',
  'legacy-remark': 'legacy-remark',
} as const;
